export default "__VITE_ASSET__BemSRd88__"